// import React, { useState } from "react";
// import { formatINR, sumField, safeArray } from "egov-ui-kit/utils/commons";

// const LEVELS = [{ key: "ulbs", label: "ULB Name", childKey: null }];

// const ReceiptDetailTable = ({ item, financialYear, ulbName, onBack , fetchSchemeDetailGrant , schemeDetailGrant, ulbType, fromDate, toDate }) => {
//   const receipts = safeArray(item.grantReceipts);
//   const totalReceived = receipts.reduce((acc, r) => acc + Number(r.receivedGrant || 0), 0);
//   const totalUtilized = receipts.reduce((acc, r) => acc + Number(r.utilizedGrant || 0), 0);
//   const totalRemaining = receipts.reduce((acc, r) => acc + Number(r.remainingBalance || 0), 0);

//   return (
//     <div className="receipt-card">
//       {/* HEADER */}
//       <div className="zone-wise-header">
//         <div className="header wrapper-header">
//           <button className="btn btn-secondary back-button" onClick={onBack}>
//             Back
//           </button>
//           <div>
//             <h2>{item.name}</h2>
//           </div>
//         </div>
//         <div className="receipt-header">
//           <span>Financial Year : {financialYear}</span>
//           <span>|</span>
//           <span>ULB : {ulbName}</span>
//         </div>
//       </div>

//       {/* DETAIL TABLE */}
//       <div className="table-responsive scrolling-table">
//         <table className="table receipt-table mb-0">
//           <thead>
//             <tr>
//               <th>Account Name</th>
//               <th>Account Code</th>
//               <th>Total Balance</th>
//               {/* <th>Utilized Grant</th>
//               <th>Unutilized Grant</th> */}
//             </tr>
//           </thead>
//           <tbody>
//             {receipts.length > 0 ? (
//               <React.Fragment>
//                 {receipts.map((r) => (
//                   <tr key={r.id}>
//                     <td>{r.accountHead}</td>
//                     <td>{r.accountCode}</td>
//                     <td>{formatINR(r.receivedGrant)}</td>
//                     {/* <td>{formatINR(r.utilizedGrant)}</td>
//                     <td>{formatINR(r.remainingBalance)}</td> */}
//                   </tr>
//                 ))}
//               </React.Fragment>
//             ) : (
//               <tr>
//                 <td colSpan="5" style={{ textAlign: "center" }}>
//                   No Grant Records Found
//                 </td>
//               </tr>
//             )}
//           </tbody>

//           {receipts.length > 0 && (
//             <tfoot className="tfoot-bottom">
//               <tr className="total-row">
//                 <td colSpan="2"></td>
//                 <td style={{ textAlign: "center" }}>{formatINR(totalReceived)}</td>
//                 {/* <td>{formatINR(totalUtilized)}</td>
//                 <td>{formatINR(totalRemaining)}</td> */}
//               </tr>
//             </tfoot>
//           )}
//         </table>
//       </div>
//     </div>
//   );
// };

// // ─────────────────────────────────────────────
// // MAIN COMPONENT
// // ─────────────────────────────────────────────
// const GrantAmountTable = ({ grantDetails }) => {
//   const tableData = grantDetails && grantDetails;
//   const totalGrantSum = safeArray(tableData.ulbs).reduce((acc, ulb) => acc + (Number(ulb.totalGrantAmount) || 0), 0);

//   const [selectedReceipt, setSelectedReceipt] = useState(null);

//   if (selectedReceipt) {
//     return (
//       <ReceiptDetailTable
//         item={selectedReceipt}
//         financialYear={tableData.financialYear}
//         ulbName={tableData.ulbName}
//         onBack={() => setSelectedReceipt(null)}
//       />
//     );
//   }

//   const levelConfig = LEVELS[0];
//   const currentRows = safeArray(tableData[levelConfig.key]);
//   const currentTitle = "ULB Wise Grant Amount";
//   const totalsRow = tableData.totals;

//   const handleDrillDown = (item) => {
//     setSelectedReceipt(item);
//   };

//   return (
//     <div className="receipt-card">
//       {/* HEADER */}
//       <div className="zone-wise-header">
//         <div className="header wrapper-header">
//           <div className="icon-wrapper">
//             <i className="material-icons">description</i>
//           </div>
//           <div>
//             <h2>{currentTitle}</h2>
//           </div>
//         </div>
//         <div className="receipt-header">
//           <span>Financial Year : {tableData.financialYear}</span>
//           <span>|</span>
//           <span>ULB : {tableData.ulbName}</span>
//         </div>
//       </div>

//       {/* MAIN DRILL DOWN TABLE */}
//       <div className="table-responsive">
//         <table className="table receipt-table mb-0">
//           <thead>
//             <tr>
//               <th>{levelConfig.label}</th>
//               <th>Grant Balance</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentRows.length > 0 ? (
//               <React.Fragment>
//                 {currentRows.map(function (item) {
//                   return (
//                     <tr key={item.id}>
//                       <td>{item.name}</td>
//                       <td>
//                         <a
//                           href="#"
//                           className="link-cell"
//                           onClick={function (e) {
//                             e.preventDefault();
//                             handleDrillDown(item);
//                           }}
//                         >
//                           {formatINR(item.totalGrantAmount)}
//                         </a>
//                       </td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="total-row">
//                   <td>Total</td>
//                   <td>{formatINR(totalGrantSum)}</td>
//                 </tr>
//               </React.Fragment>
//             ) : (
//               <tr>
//                 <td colSpan="2" style={{ textAlign: "center" }}>
//                   No Record Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default GrantAmountTable;


import React, { useState } from "react";
import { getLocale } from "egov-ui-kit/utils/localStorageUtils";
import { formatINR, sumField, safeArray } from "egov-ui-kit/utils/commons";

const LEVELS = [{ key: "ulbs", label: "ULB Name", childKey: null }];

// —— Normalizers ————————————————————————————
const normalizeSchemeList = (rawList) =>
  safeArray(rawList).map((s, idx) => ({
    id: s.id || `scheme_${idx}`,
    schemeName: s.schemeName,
    subSchemeName: s.subSchemeName,
    received: s.grantReceivedAmount,
    utilized: s.billAmount,
    unutilized: s.remainingGrantBalance,
    accountCode: s.accountCode,
    grantSanctionedAmount: s.grantSanctionedAmount,
  }));

// ─────────────────────────────────────────────
// SCHEME DETAIL TABLE (3rd level — Scheme / Sub-Scheme / Received / Utilized / Un-utilized)
// ─────────────────────────────────────────────
const SchemeDetailTable = ({ accountItem, financialYear, ulbName, onBack, schemeDetailGrant }) => {
  const schemes = normalizeSchemeList(schemeDetailGrant ? schemeDetailGrant.grants : []);

  const totalGrantSanctioned = sumField(schemes, "grantSanctionedAmount");
  const totalReceived = sumField(schemes, "received");
  const totalUtilized = sumField(schemes, "utilized");
  const totalUnutilized = sumField(schemes, "unutilized");

  const isLoading = !schemeDetailGrant;

  return (
    <div className="receipt-card">
      {/* HEADER */}
      <div className="zone-wise-header">
        <div className="header wrapper-header">
          <button className="btn btn-secondary back-button" onClick={onBack}>
            Back
          </button>
          <div>
            <h2>{accountItem.accountHead}</h2>
          </div>
        </div>
        <div className="receipt-header">
          <span>Financial Year : {financialYear}</span>
          <span>|</span>
          <span>ULB : {ulbName}</span>
        </div>
      </div>

      {/* DETAIL TABLE */}
      <div className="table-responsive scrolling-table">
        <table className="table receipt-table mb-0">
          <thead>
            <tr>
              <th>Scheme</th>
              <th>Sub-Scheme</th>
              <th>Grant Sanctioned Amount</th>
              <th>Balance for Received</th>
              <th>Utilized</th>
              <th>Un-utilized</th>
            </tr>
          </thead>
          <tbody>
            {schemes.length > 0 ? (
              <React.Fragment>
                {schemes.map((s) => (
                  <tr key={s.id}>
                    <td>{s.schemeName}</td>
                    <td>{s.subSchemeName}</td>
                    <td>{formatINR(s.grantSanctionedAmount)}</td>
                    <td>{formatINR(s.received)}</td>
                    <td>{formatINR(s.utilized)}</td>
                    <td>{formatINR(s.unutilized)}</td>
                  </tr>
                ))}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  {isLoading ? "Loading scheme details..." : "No Scheme Records Found"}
                </td>
              </tr>
            )}
          </tbody>

          {schemes.length > 0 && (
            <tfoot className="tfoot-bottom">
              <tr className="total-row">
                <td colSpan="2" style={{ textAlign: "left" }}>
                  Total
                </td>
                <td>{formatINR(totalGrantSanctioned)}</td>
                <td>{formatINR(totalReceived)}</td>
                <td>{formatINR(totalUtilized)}</td>
                <td>{formatINR(totalUnutilized)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────
// ACCOUNT DETAIL TABLE (2nd level — ULB's grant receipts / accounts)
// ─────────────────────────────────────────────
const ReceiptDetailTable = ({
  item,
  financialYear,
  ulbName,
  onBack,
  fetchSchemeDetailGrant,
  schemeDetailGrant,
  ulbType,
  fromDate,
  toDate,
}) => {
  const receipts = safeArray(item.grantReceipts);
  const totalReceived = receipts.reduce((acc, r) => acc + Number(r.receivedGrant || 0), 0);
  const totalUtilized = receipts.reduce((acc, r) => acc + Number(r.utilizedGrant || 0), 0);
  const totalRemaining = receipts.reduce((acc, r) => acc + Number(r.remainingBalance || 0), 0);

  const [selectedAccount, setSelectedAccount] = useState(null);

  // —— Scheme detail view ————————————————————
  if (selectedAccount) {
    return (
      <SchemeDetailTable
        accountItem={selectedAccount}
        financialYear={financialYear}
        ulbName={ulbName}
        schemeDetailGrant={schemeDetailGrant}
        onBack={() => setSelectedAccount(null)}
      />
    );
  }

  const handleSchemeDrillDown = (r) => {
    const payload = {
      financialYear: financialYear,
      fromDate: fromDate || null,
      toDate: toDate || null,
      ulbType: ulbType,
      ulbName: item.tenantId,
      zoneName: null,
      deptCode: null,
      locale: getLocale(),
      accountCode: r.accountCode,
    };
    fetchSchemeDetailGrant(payload);
    setSelectedAccount(r);
  };

  return (
    <div className="receipt-card">
      {/* HEADER */}
      <div className="zone-wise-header">
        <div className="header wrapper-header">
          <button className="btn btn-secondary back-button" onClick={onBack}>
            Back
          </button>
          <div>
            <h2>{item.name}</h2>
          </div>
        </div>
        <div className="receipt-header">
          <span>Financial Year : {financialYear}</span>
          <span>|</span>
          <span>ULB : {ulbName}</span>
        </div>
      </div>

      {/* DETAIL TABLE */}
      <div className="table-responsive scrolling-table">
        <table className="table receipt-table mb-0">
          <thead>
            <tr>
              <th>Account Name</th>
              <th>Account Code</th>
              <th>Total Balance</th>
              {/* <th>Utilized Grant</th>
              <th>Unutilized Grant</th> */}
            </tr>
          </thead>
          <tbody>
            {receipts.length > 0 ? (
              <React.Fragment>
                {receipts.map((r) => (
                  <tr key={r.id}>
                    <td>{r.accountHead}</td>
                    <td>{r.accountCode}</td>
                    <td>
                      <a
                        href="#"
                        className="link-cell"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSchemeDrillDown(r);
                        }}
                      >
                        {formatINR(r.receivedGrant)}
                      </a>
                    </td>
                    {/* <td>{formatINR(r.utilizedGrant)}</td>
                    <td>{formatINR(r.remainingBalance)}</td> */}
                  </tr>
                ))}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No Grant Records Found
                </td>
              </tr>
            )}
          </tbody>

          {receipts.length > 0 && (
            <tfoot className="tfoot-bottom">
              <tr className="total-row">
                <td colSpan="2"></td>
                <td style={{ textAlign: "center" }}>{formatINR(totalReceived)}</td>
                {/* <td>{formatINR(totalUtilized)}</td>
                <td>{formatINR(totalRemaining)}</td> */}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────
const GrantAmountTable = ({
  grantDetails,
  fetchSchemeDetailGrant, // fn to trigger the scheme-wise API call
  schemeDetailGrant, // scheme-wise API response (fetched on "Total Balance" click)
  ulbType,
  fromDate,
  toDate,
}) => {
  const tableData = grantDetails && grantDetails;
  const totalGrantSum = safeArray(tableData.ulbs).reduce((acc, ulb) => acc + (Number(ulb.totalGrantAmount) || 0), 0);

  const [selectedReceipt, setSelectedReceipt] = useState(null);

  if (selectedReceipt) {
    return (
      <ReceiptDetailTable
        item={selectedReceipt}
        financialYear={tableData.financialYear}
        ulbName={tableData.ulbName}
        onBack={() => setSelectedReceipt(null)}
        fetchSchemeDetailGrant={fetchSchemeDetailGrant}
        schemeDetailGrant={schemeDetailGrant}
        ulbType={ulbType}
        fromDate={fromDate}
        toDate={toDate}
      />
    );
  }

  const levelConfig = LEVELS[0];
  const currentRows = safeArray(tableData[levelConfig.key]);
  const currentTitle = "ULB Wise Grant Amount";
  const totalsRow = tableData.totals;

  const handleDrillDown = (item) => {
    setSelectedReceipt(item);
  };

  return (
    <div className="receipt-card">
      {/* HEADER */}
      <div className="zone-wise-header">
        <div className="header wrapper-header">
          <div className="icon-wrapper">
            <i className="material-icons">description</i>
          </div>
          <div>
            <h2>{currentTitle}</h2>
          </div>
        </div>
        <div className="receipt-header">
          <span>Financial Year : {tableData.financialYear}</span>
          <span>|</span>
          <span>ULB : {tableData.ulbName}</span>
        </div>
      </div>

      {/* MAIN DRILL DOWN TABLE */}
      <div className="table-responsive">
        <table className="table receipt-table mb-0">
          <thead>
            <tr>
              <th>{levelConfig.label}</th>
              <th>Grant Balance</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              <React.Fragment>
                {currentRows.map(function (item) {
                  return (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>
                        <a
                          href="#"
                          className="link-cell"
                          onClick={function (e) {
                            e.preventDefault();
                            handleDrillDown(item);
                          }}
                        >
                          {formatINR(item.totalGrantAmount)}
                        </a>
                      </td>
                    </tr>
                  );
                })}
                <tr className="total-row">
                  <td>Total</td>
                  <td>{formatINR(totalGrantSum)}</td>
                </tr>
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="2" style={{ textAlign: "center" }}>
                  No Record Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GrantAmountTable;


// WEBPACK FOOTER //
// src/modules/employee/Home/GrantAmountTable.js